const API_BASE = "http://127.0.0.1:8000/api";

const API = {
  hospitals: `${API_BASE}/hospitals/?format=json`,
  wards: `${API_BASE}/wards/?format=json`,
  rooms: `${API_BASE}/rooms/?format=json`,
  beds: `${API_BASE}/beds/?format=json`,
  devices: `${API_BASE}/devices/devices/?format=json`,
  deviceAssignments: `${API_BASE}/devices/device-assignments/?format=json`,
  admissions: `${API_BASE}/patients/admissions/?format=json`,
};

async function parseJsonSafe(response) {
  const text = await response.text();

  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {
      detail: text || "Invalid server response",
    };
  }
}

function getHeaders() {
  const accessToken = localStorage.getItem("access_token");
  const token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (token) {
    headers.Authorization = `Token ${token}`;
  }

  return headers;
}

function normalizeListResponse(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

async function apiGet(url) {
  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(),
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return normalizeListResponse(data);
}

async function apiPost(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await parseJsonSafe(response);

  if (!response.ok) {
    throw data;
  }

  return data;
}

export const getHospitals = () => apiGet(API.hospitals);
export const getWards = () => apiGet(API.wards);
export const getRooms = () => apiGet(API.rooms);
export const getBeds = () => apiGet(API.beds);
export const getDevices = () => apiGet(API.devices);
export const getAdmissions = () => apiGet(API.admissions);
export const getDeviceAssignments = () => apiGet(API.deviceAssignments);

export const createDeviceAssignment = (payload) =>
  apiPost(API.deviceAssignments, payload);